import React from "react";
import { useViewMode } from "../contexts/ViewModeContext";

/**
 * AnnotationEntry component for displaying annotation entries with delete button
 * Used for Time Signature, Key, and Tempo changes
 */
const AnnotationEntry = ({ label, onDelete, onClick }) => {
  const {isViewMode} = useViewMode();

  return (
    <div className="flex items-center space-x-2 mb-2">
      <div 
        className="flex items-center justify-between bg-gray-200 rounded-md px-3 py-2 flex-grow cursor-pointer"
        onClick={isViewMode ? undefined : onClick}
      >
        <span className="overflow-hidden text-overflow-ellipsis whitespace-nowrap max-w-[150px] block">{label}</span>
        {!isViewMode ? 
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="ml-2 w-6 h-6 flex items-center justify-center bg-gray-300 rounded-full hover:bg-gray-400"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button> :
          null
        }
      </div>
    </div>
  );
};

export default AnnotationEntry;
